module.exports = __webpack_public_path__ + "images/emoji/honeybee.5c9d6132112f0110044f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/honeybee.png
// module id = cZWu
// module chunks = 13